import {Feature} from "./Feature";
import {NumberOrUnlimited} from "../../number";

export enum AgencyPlanType {
  NO_PLAN = "NO_PLAN",
  BETA = "BETA",
  PROFESSIONAL = "PROFESSIONAL",
  ENTERPRISE = "ENTERPRISE",
  BUSINESS = "BUSINESS",
  TEAM = "TEAM",
  LIVIAN = "LIVIAN",
  BASIC = "BASIC",
  STARTER = "STARTER",
  GROWTH = "GROWTH",
  SCALE = "SCALE"
}

export const PlanNameToAgencyPlanType: Record<string, AgencyPlanType> = {
  Beta: AgencyPlanType.BETA,
  Enterprise: AgencyPlanType.ENTERPRISE,
  Business: AgencyPlanType.BUSINESS,
  Team: AgencyPlanType.TEAM,
  Professional: AgencyPlanType.PROFESSIONAL,
  Livian: AgencyPlanType.LIVIAN,
  Basic: AgencyPlanType.BASIC,
  Starter: AgencyPlanType.STARTER,
  Growth: AgencyPlanType.GROWTH,
  Scale: AgencyPlanType.SCALE
};

export const AgencyPlanTypeLabel: Record<AgencyPlanType, string> = {
  [AgencyPlanType.NO_PLAN]: "No Plan",
  [AgencyPlanType.ENTERPRISE]: "Enterprise",
  [AgencyPlanType.BUSINESS]: "Business",
  [AgencyPlanType.BETA]: "Beta",
  [AgencyPlanType.PROFESSIONAL]: "Professional",
  [AgencyPlanType.TEAM]: "Team",
  [AgencyPlanType.LIVIAN]: "Livian",
  [AgencyPlanType.BASIC]: "Basic",
  [AgencyPlanType.STARTER]: "Starter",
  [AgencyPlanType.GROWTH]: "Growth",
  [AgencyPlanType.SCALE]: "Scale"
};

export interface AgencyPlanUpgradeRequest {
  at: string;
  remarks: string;
  requestedByAgentId: string;
}

export interface AgencyPlan {
  planType: AgencyPlanType;
  startDate?: string;
  expireDate?: string;
  nextBillingDate?: string;
  creditsNextBillingDate?: string;
  renewalDate?: string;
  features: Feature[];
  allowedNumOfUsers: NumberOrUnlimited;
  allowedNumOfContacts: NumberOrUnlimited;
  allowedNumOfLandingPages: NumberOrUnlimited;
  allowedNumOfPersonalizedURLs: NumberOrUnlimited;
  allowedNumOfWidgets: NumberOrUnlimited;
  allowedNumOfBrands: NumberOrUnlimited;
  allowedNumOfSegments: NumberOrUnlimited;
  allowedNumOfSegmentWatchPerAgent: NumberOrUnlimited;
  allowedNumOfWorkflows: NumberOrUnlimited;
  updatedAt: string;
  remarks?: string;
  upgradeRequest?: AgencyPlanUpgradeRequest;
  totalRecurringCredits: number;
}
